import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Sparkles, ArrowRight, Users } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReferralLanding() {
  const { code } = useParams();
  const nav = useNavigate();
  const [state, setState] = useState({ status: "loading" });

  useEffect(() => {
    if (!code) return;
    (async () => {
      try {
        const res = await axios.get(`${API}/referral/${code.toUpperCase()}`);
        const info = res.data;
        try {
          localStorage.setItem("ppe_referral_coupon", info.coupon_id);
          localStorage.setItem("ppe_referral_percent", String(info.percent_off || 15));
        } catch {}
        setState({ status: "ok", info });
        toast.success(`Referral link active · ${info.percent_off}% off your first pass`);
      } catch (e) {
        setState({ status: "notfound" });
      }
    })();
  }, [code]);

  return (
    <div className="min-h-screen w-full grid-bg flex items-center justify-center" data-testid="referral-landing">
      <div className="border border-white/10 bg-black/70 backdrop-blur-xl p-10 max-w-lg text-center">
        <div className="flex items-center gap-2 text-[10px] tracking-[0.4em] text-[#F0ABFC] justify-center mb-3">
          <Users size={14} /> REFERRAL · WELCOME
        </div>
        {state.status === "loading" && (
          <>
            <div className="font-display text-3xl tracking-tighter text-white/70">Loading…</div>
          </>
        )}
        {state.status === "notfound" && (
          <>
            <div className="font-display text-3xl tracking-tighter text-white">Link not found</div>
            <p className="text-xs text-white/50 mt-3 tracking-wider">
              This referral code doesn't exist. It may have been mistyped or removed.
            </p>
            <button
              data-testid="referral-back-btn"
              onClick={() => nav("/")}
              className="mt-8 px-5 py-3 border border-cyan-300 text-cyan-300 hover:bg-cyan-300 hover:text-black transition-colors text-xs tracking-[0.3em]"
            >
              ENTER THE ARCADE →
            </button>
          </>
        )}
        {state.status === "ok" && (
          <>
            <div className="font-display text-4xl tracking-tighter text-white">
              You're in.{" "}
              <span className="text-[#F0ABFC]" style={{ textShadow: "0 0 22px rgba(240,171,252,0.6)" }}>
                {state.info.percent_off}% off
              </span>
            </div>
            <p className="text-xs text-white/60 mt-3 tracking-wider" data-testid="referral-code-label">
              Code <span className="text-white font-mono">{state.info.code}</span> will auto-apply on your first Season Pass or Pro purchase.
            </p>
            <div className="flex items-center gap-2 text-[10px] tracking-[0.3em] text-[#F0ABFC] justify-center mt-6">
              <Sparkles size={12} /> KEEP MOVING
            </div>
            <button
              data-testid="referral-continue-btn"
              onClick={() => nav("/")}
              className="mt-6 px-6 py-3 border border-[#F0ABFC] text-[#F0ABFC] hover:bg-[#F0ABFC] hover:text-black transition-colors text-xs tracking-[0.3em] flex items-center gap-2 mx-auto"
              style={{ boxShadow: "0 0 20px rgba(240,171,252,0.4)" }}
            >
              PLAY NOW <ArrowRight size={14} />
            </button>
          </>
        )}
      </div>
    </div>
  );
}
